module.exports = __webpack_public_path__ + "img/diente_paciente.f11ab657.png";